import { createSlice } from "@reduxjs/toolkit";

const getAllClassWithStreamSubStreamSectionSlice = createSlice({
  name: "classWithStreamSubStreamSectionListList",
  initialState: {
    classWithStreamSubStreamSectionList : [],
    loading: false,
    error: null,
  },
  reducers: {
    getAllClassWithStreamSubStreamSectionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAllClassWithStreamSubStreamSectionSuccess: (state, action) => {
      state.loading = false;
      state.classWithStreamSubStreamSectionList = action.payload;
    },
    getAllClassWithStreamSubStreamSectionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearAllClassWithStreamSubStreamSectionList: (state) => {
      state.classWithStreamSubStreamSectionList = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getAllClassWithStreamSubStreamSectionRequest,
  getAllClassWithStreamSubStreamSectionSuccess,
  getAllClassWithStreamSubStreamSectionFailure,
  clearAllClassWithStreamSubStreamSection,
} = getAllClassWithStreamSubStreamSectionSlice.actions;

export default getAllClassWithStreamSubStreamSectionSlice.reducer;
